import { ref, computed, watchEffect } from 'vue';

export type Lang = 'zh' | 'en';

const STORAGE_KEY = 'aurora-lang';
const initial: Lang = (() => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'zh' || saved === 'en') return saved;
  } catch {
    // SSR / privacy mode
  }
  return 'zh';
})();

const lang = ref<Lang>(initial);

watchEffect(() => {
  try {
    localStorage.setItem(STORAGE_KEY, lang.value);
  } catch {
    // ignore
  }
});

export function useLang() {
  const isZh = computed(() => lang.value === 'zh');
  function setLang(v: Lang) {
    lang.value = v;
  }
  function toggle() {
    lang.value = lang.value === 'zh' ? 'en' : 'zh';
  }
  function t(zh: string, en: string): string {
    return lang.value === 'zh' ? zh : en;
  }
  return { lang, isZh, setLang, toggle, t };
}
